import './App.css'
import 'normalize.css/normalize.css'

import AppRouter from './AppRouter'
import './firebase'

import configureStore from './redux/configureStore'
import { Provider } from 'react-redux'

import './styles.scss'

const store = configureStore()

export default function App() {
  return (
    <Provider store = {store}>
          <AppRouter />
    </Provider>
  )
}
